(function (Drupal) {
  Drupal.behaviors.modal = {
    attach: function (context, settings) {
      const modalLinks = context.querySelectorAll(".modal-link");
      modalLinks.forEach((link) => {
        if (!link.dataset.modalProcessed) {
          link.dataset.modalProcessed = "true";

          link.addEventListener("click", (e) => {
            e.preventDefault();
            const toOpen = document.querySelector(link.getAttribute("href"));
            if (toOpen) {
              toOpen.classList.add("open");
            }
          });
        }
      });

      const modals = context.querySelectorAll(".modal");
      modals.forEach((modal) => {
        const closeButton = modal.querySelector(".close");
        if (closeButton) {
          closeButton.addEventListener("click", () => {
            modal.classList.remove("open");
          });
        }

        const modalContent = modal.querySelector(".modal-content");
        if (modalContent) {
          modalContent.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        }

        modal.addEventListener("click", () => {
          modal.classList.remove("open");
        });
      });
    },
  };
})(Drupal);
